import { useEffect, useState } from 'react';
import { gtmEventSelectPlan } from '../utils/analytics';
import { URL_CONFIG_GET_PARAM } from '../utils/constants';

const getDefaultUserData = () => ({
	step: 0,
});

export const useUserData = () => {
	const [userData, setUserData] = useState(getDefaultUserData());

	useEffect(() => {
		// 1. Check if configuration data is passed in the URL.
		const url = new URL(window.location);
		if (url.searchParams.has(URL_CONFIG_GET_PARAM)) {
			try {
				const decodedURI = decodeURI(url.searchParams.get(URL_CONFIG_GET_PARAM));
				const urlConfigData = JSON.parse(decodedURI);

				// Delete the URL parameter after parsing it.
				url.searchParams.delete(URL_CONFIG_GET_PARAM);
				history.replaceState(null, '', url.href);

				setUserData(urlConfigData);
			} catch (e) {
				console.warn('When parsing pricing user data from the URL, an error occurred:', e);
			}
		}
	}, []);

	/**
	 * Helper functions to modify user data.
	 */

	const onPlanSelect = (planKey, planData, paymentInterval, units) => {
		gtmEventSelectPlan({ plan: planKey, units, paymentInterval });

		setUserData((userData) => {
			// Determine whether to skip the packages step if there are no packages available.
			const step = planData.consulting_packages.available_packages.length ? 1 : 2;
			return { ...userData, step, plan: planKey, paymentInterval, units, packages: [] };
		});
	};

	const onChangePlan = () => {
		setUserData(getDefaultUserData);
	};

	const onPrevBtnClick = () => {
		setUserData((userData) => {
			if (userData.step === 1) {
				return getDefaultUserData();
			} else {
				return { ...userData, step: userData.step - 1 };
			}
		});
	};

	const onNextBtnClick = () => {
		setUserData((userData) => ({ ...userData, step: userData.step + 1 }));
	};

	const updatePackages = (packages) => {
		setUserData((userData) => ({ ...userData, packages }));
	};

	return { userData, onPlanSelect, onChangePlan, onPrevBtnClick, onNextBtnClick, updatePackages };
};
